"use client"
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/ButtonShadcn";
import Card from "@/components/ui/Card";
import Link from "next/link";
import FaqRefferal from "@/components/home/FaqRefferal";
import useAuthInfo from "@/store/auth";
import HowItWorksReferral from "@/components/referral/HowItWorksReferral";
import { AjaxGet, AjaxGetAnon } from "@/util/Ajax";
import { Icon } from "@iconify/react";
import { toast } from "sonner";
import Lottie from "lottie-react";
import success from "@/public/assets/images/animations/Success.json";

function page() {
  const userData = useAuthInfo((state) => state);
  const [showBanner, setShowBanner] = useState(0);
  const [referalCode, setReferalCode] = useState("");

  useEffect(() => {
    CheckIfBannerShouldShow();
    getMyRefferalCode();
  }, []);

  const CheckIfBannerShouldShow = async () => {
    var res = await AjaxGetAnon(`MarketingBudget`);
    if (res.data) {
      setShowBanner(res.data);
    }
  };

  useEffect(() => {
    if (userData.apiToken) {
      getMyRefferalCode();
    }
  }, [userData]);

  const getMyRefferalCode = async () => {
    var res = await AjaxGet(userData, `Referral/MyCode`);
    if (res.data) {
      setReferalCode(res.data.referralCode);
    }
  };

  const CopyToClipboard = async (text) => {
    if (typeof navigator !== "undefined" && navigator.clipboard) {
      await navigator.clipboard.writeText(text);
      toast("Url Copied", {
        description: "You can now easily share this value",
      });
    }
  };

  return (
    <>
      {showBanner > 0 && (
        <div
          id="sticky-banner"
          tabindex="-1"
          class=" start-0 z-[60] flex justify-between w-full p-4 border-b border-gray-200 bg-gray-50 dark:bg-gray-700 dark:border-gray-600"
        >
          <div class="flex items-center mx-auto">
            <p class="flex items-center text-sm font-normal text-gray-500 dark:text-gray-400">
              <span class="inline-flex p-1 me-3 bg-gray-200 rounded-full dark:bg-gray-600 w-8 h-8 items-center justify-center flex-shrink-0">
                <Icon
                  style={{ fontSize: "24px" }}
                  icon={"heroicons-outline:banknotes"}
                />
                <span class="sr-only">Light bulb</span>
              </span>
              <span>
                Earn Rewards for Referrals! 🎉. At least{" "}
                <strong className="text-primary-500">
                  R {showBanner.toFixed(2)}
                </strong>{" "}
                per referral!{" "}
                {referalCode && (
                  <span
                    onClick={() => {
                      CopyToClipboard(
                        `https://www.eyamapp.com/register?referralCode=${referalCode}`
                      );
                    }}
                    class="inline cursor-pointer font-medium text-blue-600 underline dark:text-blue-500 underline-offset-2 decoration-600 dark:decoration-500 decoration-solid hover:no-underline"
                  >
                    Copy Url
                  </span>
                )}
                {!referalCode && (
                  <Link
                    href={"/supply"}
                    class="inline font-medium text-blue-600 underline dark:text-blue-500 underline-offset-2 decoration-600 dark:decoration-500 decoration-solid hover:no-underline"
                  >
                    Get my Referal Code
                  </Link>
                )}
              </span>
            </p>
          </div>
        </div>
      )}

      <div className="container">
        <div className="flex flex-col md:flex-row md:mt-16 mt-6 mb-8">
          <motion.div
            initial={{ opacity: 0, translateX: -50 }}
            whileInView={{ opacity: 100, translateX: 0 }}
            transition={{ duration: 0.3, delay: 0.1 }}
            className="w-full md:w-1/2 flex flex-col justify-center"
          >
            <h1 className="leading-snug text-3xl md:text-6xl mb-4 md:mb-4">
              Earn Up to <strong className="text-blue-500">R5000</strong> for
              Every Successful Referral!
            </h1>
            <motion.p
              initial={{ opacity: 0, translateY: 50 }}
              whileInView={{ opacity: 100, translateY: 0 }}
              transition={{ duration: 0.3, delay: 0.4 }}
              className="text-lg font-medium md:mt-5 max-w-2xl"
            >
              At Eyam, we value the power of connections! Now, you can earn up
              to R5000 for every successful referral you make. It’s simple,
              rewarding, and a great way to make a difference while putting
              extra cash in your pocket.
            </motion.p>
            {!userData.apiToken && (
              <Button
                link={"/register"}
                className="mt-10 mb-10 bg-[#1F205A] text-[#fff] rounded-lg md:w-1/2 w-full"
              >
                Get Started
              </Button>
            )}
            {userData.apiToken && (
              <Button
                link={"/portfolio#referral"}
                className="mt-10 mb-10 bg-[#1F205A] text-[#fff] rounded-lg md:w-1/2 w-full"
              >
                View My Referrals
              </Button>
            )}
          </motion.div>
          <motion.div
            initial={{ opacity: 0, translateX: 50 }}
            whileInView={{ opacity: 100, translateX: 0 }}
            transition={{ duration: 0.3, delay: 0.4 }}
            className="w-full md:w-1/2"
          >
            <img src="/assets/images/refferal.svg" alt="" className="w-full" />
          </motion.div>
        </div>
        {!referalCode && <HowItWorksReferral />}
        {referalCode && (
          <div className="flex flex-col gap-8 text-center items-center justify-center">
            <h4>You have been successfully registered</h4>
            <div className="overflow-hidden flex w-1/2 md:w-1/5 ml-auto mr-auto">
              <Lottie className="w-full" animationData={success} loop={false} />
            </div>
            <div className="flex md:flex-row flex-col w-full gap-4">
              <div className="w-full md:w-1/2">
                <h6 className="mb-4">Referral Link</h6>
                <div className="bg-black-200 p-4 rounded-lg border flex items-center justify-between">
                  <p className="text-sm text-gray-800 truncate ">
                    https://www.eyamapp.com/register?referralCode=
                    {referalCode}
                  </p>
                  <button
                    onClick={() => {
                      CopyToClipboard(
                        `https://www.eyamapp.com/register?referralCode=${referalCode}`
                      );
                    }}
                    className="bg-blue-500 text-white text-sm px-4 py-2 rounded-lg hover:bg-blue-600"
                  >
                    Copy
                  </button>
                </div>
              </div>
              <div className="w-full md:w-1/2">
                <h6 className="mb-4">Referral Code</h6>

                <div className="bg-black-200 p-4 rounded-lg border flex items-center justify-between w-full ">
                  <p className="text-sm text-gray-800 truncate">
                    {referalCode}
                  </p>
                  <button
                    onClick={() => {
                      CopyToClipboard(referalCode);
                    }}
                    className="bg-blue-500 text-white text-sm px-4 py-2 rounded-lg hover:bg-blue-600"
                  >
                    Copy
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        <FaqRefferal />
      </div>
    </>
  );
}

export default page;
